import { render, staticRenderFns } from "./loginMain.vue?vue&type=template&id=185df098&"
import script from "./loginMain.vue?vue&type=script&lang=js&"
export * from "./loginMain.vue?vue&type=script&lang=js&"
import style0 from "./loginMain.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports